var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteamChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1456_1449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12551 0.957275C3.69103 0.957275 0.877527 3.4047 0.610352 6.51474L4.11443 7.85369C4.42041 7.65973 4.78379 7.55601 5.15591 7.55643C5.19068 7.55643 5.22505 7.55731 5.2589 7.55904L6.8174 5.47127V5.44204C6.8174 4.18578 7.92332 3.16347 9.28281 3.16347C10.6422 3.16347 11.7482 4.18578 11.7482 5.44204C11.7482 6.69825 10.6422 7.72098 9.28281 7.72098C9.26394 7.72098 9.24559 7.72056 9.22682 7.72014L7.00411 9.18532C7.00554 9.21249 7.00646 9.23963 7.00646 9.26634C7.00646 10.2098 6.17623 10.9771 5.15591 10.9771C4.26026 10.9771 3.51089 10.386 3.34156 9.60367L0.835208 8.64593C1.61139 11.1821 4.13274 13.0415 7.12551 13.0415C10.7364 13.0415 13.6632 10.336 13.6632 6.99939C13.6632 3.66237 10.7364 0.957275 7.12551 0.957275ZM4.70732 10.1252L3.90431 9.81847C4.04642 10.0924 4.29289 10.3216 4.61982 10.4475C5.32636 10.7197 6.1411 10.41 6.4356 9.75641C6.57818 9.44216 6.57902 9.08898 6.43795 8.77416C6.29681 8.4571 6.03009 8.20979 5.68812 8.07797C5.34803 7.94746 4.98393 7.95217 4.66403 8.06378L5.49386 8.38084C6.01505 8.58163 6.26153 9.13475 6.04422 9.61641C5.82737 10.098 5.22852 10.326 4.70732 10.1252ZM10.9256 5.44204C10.9256 4.60502 10.1885 3.92349 9.28296 3.92349C8.37696 3.92349 7.63983 4.60502 7.63983 5.44204C7.63983 6.27911 8.37696 6.96021 9.28296 6.96021C10.1885 6.96021 10.9256 6.27911 10.9256 5.44204ZM8.05145 5.43947C8.05145 4.80964 8.60416 4.29916 9.28536 4.29916C9.96696 4.29916 10.5197 4.80964 10.5197 5.43947C10.5197 6.0693 9.96696 6.57983 9.28531 6.57983C8.60416 6.57983 8.05145 6.06926 8.05145 5.43947Z",
    fill: "#6B758B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_1449"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.458008,
    y: 0.817871,
    width: 13.5,
    height: 12.3636,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteamChat);
export default __webpack_public_path__ + "static/media/steam-chat.70ad0028d27fc7d622bcc5d75f64f954.svg";
export { ForwardRef as ReactComponent };